import { render, staticRenderFns } from "./PublicationAudioItem.vue?vue&type=template&id=2768e7b0&lang=pug&"
import script from "./PublicationAudioItem.vue?vue&type=script&lang=js&"
export * from "./PublicationAudioItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports